const ID_FIELDS = [
  "UserID",
  "userID",
  "user_id",
  "UserId",
  "RegID",
  "reg_id",
  "RegNo",
  "reg_no",
  "RegistrationID",
  "registration_id",
];

/** Public registration id (e.g. DL2038, DK2270). */
export function formatRegId(profile) {
  if (!profile) return "—";
  for (const key of ID_FIELDS) {
    const v = profile[key];
    if (v != null && String(v).trim() && String(v).trim() !== "0") {
      return String(v).trim();
    }
  }
  const pid = profile.ProfileID ?? profile.profileID;
  if (pid != null && String(pid).trim()) return `ID-${pid}`;
  return "—";
}

/** Display line for profile header — "ID : DL2038" */
export function formatProfileIdLine(profile) {
  const id = formatRegId(profile);
  if (!id || id === "—") return null;
  return `ID : ${id}`;
}